// extracted by mini-css-extract-plugin
module.exports = {"main-section":"ProductPage_main-section__3B4OM","side-bar":"ProductPage_side-bar__1O34r","product-section":"ProductPage_product-section__3skpb"};